// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetBrandTypeCodeApprvService = {};

AssetBrandTypeCodeApprvService.getAssetBrandTypeCodeApprvList = function (
  userInput
) {
  return lossClient({
    url: "/AssetBrandType/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetBrandTypeCodeApprvService;
